import request from "./request.service";

export const getPos = async (prefix) => {
  const result = await request(`/mcp/getPos?prefix=${prefix}`);

  return result.data;
};
